import StatsBoxes from '../StatsBoxes';
import { QuarterlyStats } from '../../functions/quarterlyStats';

type StatsSectionProps = {
  quarters5d: QuarterlyStats[];
  quarters6d: QuarterlyStats[];
  workWeek: 'five' | 'six';
};

export function StatsSection({ quarters5d, quarters6d, workWeek }: StatsSectionProps) {
  return (
    <div className="mt-6 sm:mt-8">
      <StatsBoxes quarters5d={quarters5d} quarters6d={quarters6d} workWeek={workWeek} />
    </div>
  );
}
